// <fiee-toast> reports failed HTMX actions (a delete, a form posted by HTMX).
//
// For those requests the server answers an error with HX-Reswap: none, so the
// page stays as it was, and puts the message in X-Fiee-Error (URL-encoded:
// headers are ASCII and the messages are Spanish). Without this island the
// failure would be silent: the row would simply stay on screen.
export class FieeToast extends HTMLElement {
  #timer = 0;
  #onRequest = (e: Event) => this.#afterRequest(e);

  connectedCallback() {
    this.setAttribute("role", "status");
    this.setAttribute("aria-live", "polite");
    document.addEventListener("htmx:after:request", this.#onRequest);
  }

  disconnectedCallback() {
    document.removeEventListener("htmx:after:request", this.#onRequest);
  }

  show(message: string) {
    this.textContent = message;
    this.classList.add("is-visible");
    window.clearTimeout(this.#timer);
    this.#timer = window.setTimeout(() => this.classList.remove("is-visible"), 5000);
  }

  #afterRequest(e: Event) {
    const response = (e as CustomEvent).detail?.ctx?.response?.raw as Response | undefined;
    const header = response?.headers.get("X-Fiee-Error");
    if (!header) return;
    let message = header;
    try {
      message = decodeURIComponent(header);
    } catch {
      // Not encoded after all: show it as is.
    }
    this.show(message);
  }
}
